"use client";

import styled from "styled-components";

export const DrugNameWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  min-height: 3.2rem;
  padding: 0.2rem;

  div {
    font-family: var(--font-pt-serif) !important;
  }

  .article-detail-mobile-ui-true & {
    min-height: 1.6rem;
    padding: 0;

    div {
      font-size: 1.2rem !important;
    }
  }

  @media only screen and (max-width: 768px) {
    min-height: 1.6rem;
    padding: 0;

    div {
      font-size: 1.2rem !important;
    }
  }
`;

export const DrugNameTitle = styled.div`
  color: #015d8e;
  font-family: var(--font-pt-serif);
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 600;
  white-space: nowrap;
`;
